(function () {
  'use strict';

  angular.module('app').component('productCategoriesPage', productCategoryListComponent());

  function productCategoryListComponent() {
    return {
      bindings: {},
      controller: ProductCategoryListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/product-categories/product-categories-page.component.html',
    };
  }

  ProductCategoryListCtrl.$inject = [
    'UtilService',
    'AbilityService',
    '$location',
    'ProductCategoryService',
    'LanguageService',
  ];

  function ProductCategoryListCtrl(
    UtilService,
    AbilityService,
    $location,
    ProductCategoryService,
    LanguageService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_productcategory_accountadmin'),
    };

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    getDefaultLanguage();
    // getItems();
    // getAdditionalLanguages();

    function getDefaultLanguage() {
      LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
        data
      ) {
        vm.defaultLanguage = data.items.lang;

        getItems('');
      });
    }

    function getItems(selectedItem) {
      vm.filterCriteria = ProductCategoryService.getFilterCriteria();
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      ProductCategoryService.getProductCategories(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        if (selectedItem) {
          vm.UtilService.itemListChanged(selectedItem.id);
        }
      });
    }

    /*  function getAdditionalLanguages() {
      LanguageService.getLanguages({ get: 'translations', skip_check_role: true }).then(function (
        data
      ) {
        vm.additionalLanguages = data.items;
      });
    } */

    function createItem() {
      $location.path('/product_categories/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/product_categories/${item.id}`).search({ mode: mode });
    }
  }
})();
